import { ColumnConfig, CFAInvoiceColumnKey } from '../../model';

export const cfaInvoiceConfig: Record<CFAInvoiceColumnKey, ColumnConfig> = {
  invoiceNumberDate: {
    name: 'Invoice No. & Date',
    isCheckboxField: true,
    isComponent: true,
  },
  // invoiceDate: {
  //   name: 'Invoice Date',
  //   sortField: 'invoiceDate',
  //   alignment: 'flex-end',
  // },
  // coNumber: {
  //   name: 'CO Number',
  // },
  // docType: {
  //   name: 'Doc Type',
  // },
  dueDate: {
    name: 'Due Date',
    sortField: 'dueDate',
    alignment: 'flex-end',
  },
  invoiceAmount: {
    name: 'Invoice Amount',
    sortField: 'invoiceAmount',
    alignment: 'flex-end',
  },
  customerName: {
    name: 'Customer Name',
    field: 'avatarNameStatus',
  },
  reminders: {
    name: 'Reminders',
    isComponent: true,
  },
  engaged: {
    name: 'Engaged',
    isComponent: true,
  },
  status: {
    name: 'Status',
    isComponent: true,
  },

  // amountPaid: {
  //   name: 'Amount Paid',
  //   sortField: 'paidAmount',
  //   alignment: 'flex-end',
  // },
  // paymentId: {
  //   name: 'Payment ID',
  //   isComponent: true,
  // },
  // orderNumber: {
  //   name: 'Order Number',
  //   isComponent: true,
  //   isAdditional: true,
  //   isVisible: false,
  // },

  action: {
    name: 'Actions',
    alignment: 'flex-end',
  },
};
